import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { SET_PAYMENT_METHOD_AND_PLACE_ORDER } from './checkoutQueries';

const PayPalReturn = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [orderNumber, setOrderNumber] = useState(null);

    const [setPaymentAndPlaceOrder] = useMutation(SET_PAYMENT_METHOD_AND_PLACE_ORDER);

    useEffect(() => {
        const processPayPalReturn = async () => {
            try {
                // Get parameters from PayPal return URL
                const token = searchParams.get('token');
                const payerId = searchParams.get('PayerID');
                const cartId = localStorage.getItem('cartId');

                if (!token || !payerId || !cartId) {
                    throw new Error('Missing required PayPal parameters');
                }

                // Set PayPal payment method and place order
                const result = await setPaymentAndPlaceOrder({
                    variables: {
                        cartId,
                        paymentMethod: {
                            code: 'paypal_express',
                            paypal_express: {
                                payer_id: payerId,
                                token: token
                            }
                        }
                    }
                });

                const order = result.data.placeOrder.order;
                setOrderNumber(order.order_number);

                // Clear cart
                localStorage.removeItem('cartId');

                // Redirect to success page after 3 seconds
                setTimeout(() => {
                    navigate('/checkout/success', {
                        state: { orderNumber: order.order_number }
                    });
                }, 3000);

            } catch (err) {
                console.error('PayPal return processing error:', err);
                setError(err.message || 'Failed to process PayPal payment');
            } finally {
                setLoading(false);
            }
        };

        processPayPalReturn();
    }, [searchParams, navigate, setPaymentAndPlaceOrder]);

    if (loading) {
        return (
            <div className="checkout-container">
                <div className="loading-container">
                    <div className="loading-spinner" />
                    <p>Processing your PayPal payment...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="checkout-container">
                <div className="error-message">
                    <h2>Payment Processing Error</h2>
                    <p>{error}</p>
                    <button
                        onClick={() => navigate('/checkout')}
                        className="btn-primary"
                        style={{ marginTop: '1rem' }}
                    >
                        Return to Checkout
                    </button>
                </div>
            </div>
        );
    }

    if (orderNumber) {
        return (
            <div className="checkout-container">
                <div className="order-success-message">
                    <h1>PayPal Payment Successful!</h1>
                    <p>Your order number is: <strong>{orderNumber}</strong></p>
                    <p>Redirecting to success page...</p>
                    <div className="loading-spinner" style={{ margin: '1rem auto' }} />
                </div>
            </div>
        );
    }

    return null;
};

export default PayPalReturn;